import axios from 'axios';
import http from 'http';
import https from 'https';
import qs from 'qs';
import { Sentry } from 'utils';
import tracer from '../tracer';
import { AXIOS_CONFIG } from './config';
import { PLATFORM_EXTENSIONS } from '../../constants';

const getPageName = (type, level) => {
    if (type === 'search') return 'search';
    if (type === 'category' && level === 2) return 'subcategory';
    if (type === 'category' && level === 3) return 'subsubcategory';

    return '';
};

const getAncestorsParams = (context = {}) => {
    const { ancestors } = context;
    if (!ancestors) return {};

    const ancestorsParams = {};
    const level0 = ancestors[0];
    const level1 = ancestors[1];

    if (level0) {
        ancestorsParams.level_0_id = level0.id;
        ancestorsParams.level_0_name = level0.name;
    }
    if (level1) {
        ancestorsParams.level_1_id = level1.id;
        ancestorsParams.level_1_name = level1.name;
    }

    return ancestorsParams;
};

const getRequestUrlParams = (listingData, user, isNewUser) => {
    const { type, params = {} } = listingData;
    let requestParams = {};

    const pageName = getPageName(type, params.level);
    if (pageName) {
        requestParams.page_name = pageName;
    }

    if (user && user.id) {
        requestParams.user_id = user.isB2B ? user.id : 0;
    }

    if (isNewUser !== undefined) {
        requestParams.new_user = isNewUser;
    }

    const ancestorsParams = getAncestorsParams(params.context);
    requestParams = { ...requestParams, ...ancestorsParams };

    return requestParams;
};

export const getURL = (
    listingData,
    baseUrl,
    platform,
    market,
    user,
    isNewUser,
) => {
    if (!listingData || !platform || !market || !baseUrl) return null;

    const platformExtension = PLATFORM_EXTENSIONS[platform];
    const platformBaseUrl = platformExtension
        ? baseUrl.replace('.com', platformExtension)
        : baseUrl;

    const slug = 'middle_banner';
    let campaignEndpoint = `${AXIOS_CONFIG.ENDPOINT}/${platform}/${market}/${slug}`;

    const requestParams = getRequestUrlParams(listingData, user, isNewUser);
    if (Object.keys(requestParams).length) {
        campaignEndpoint = campaignEndpoint.concat(
            `?${qs.stringify(requestParams)}`,
        );
    }

    return {
        method: 'GET',
        url: `https://${platformBaseUrl}/${campaignEndpoint}`,
    };
};

const instance = axios.create({
    timeout:
        parseInt(process.env.MS_MIDDLE_BANNER_CAMPAIGN_TIMEOUT, 10) ||
        AXIOS_CONFIG.TIMEOUT,

    httpAgent: new http.Agent({
        keepAlive: true,
    }),

    httpsAgent: new https.Agent({
        rejectUnauthorized: false,
        keepAlive: true,
    }),
});

export const fetchCampaign = tracer.wrap(
    'fragment.listing.fetchMiddleBannerCampaign',
    (listingData, baseUrl, platform, market, user, isNewUser) => {
        const url = getURL(
            listingData,
            baseUrl,
            platform,
            market,
            user,
            isNewUser,
        );

        if (!url) {
            return Promise.resolve({});
        }

        return instance(url)
            .then(({ data }) => {
                const campaignData = (data && data.content?.[0]) || {};
                return {
                    campaignData,
                };
            })
            .catch(err => {
                Sentry.captureException(err);
                return {
                    err: err.message,
                };
            });
    },
);

export default { fetchCampaign };
